import { Scope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PoliciesAddQueryDetailPage } from "~/pages/shared/policy/PoliciesAddQueryDetailPage";

export type OrganizationPoliciesAddQueryDetailPageProps = {
  scope: Scope;
};

export function OrganizationPoliciesAddQueryDetailPage({
  scope,
}: OrganizationPoliciesAddQueryDetailPageProps) {
  const { policyId = "" } = useParams();

  return (
    <PoliciesAddQueryDetailPage
      scope={scope}
      sectionLabel="Organization Policies"
      renderBreadcrumbs={(policyName, queryName) => (
        <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
          <Link
            key="/dashboard"
            component={RouterLink}
            to={`/dashboard`}
            display="flex"
          >
            <HomeIcon fontSize="inherit" />
          </Link>
          <Link
            key="/organization/policies"
            component={RouterLink}
            to={`/organization/policies?${scope.params}`}
          >
            Organization Policies
          </Link>
          <Link
            key="/organization/policies/add"
            component={RouterLink}
            to={`/organization/policies/add?${scope.params}`}
          >
            Add Policies
          </Link>
          <Link
            key="/organization/policies/add/policyId"
            component={RouterLink}
            to={`/organization/policies/add/${encodeURIComponent(policyId)}?${scope.params}`}
          >
            {policyName}
          </Link>
          <Typography key="/organization/policies/add/policyId/queries/queryId">
            {queryName}
          </Typography>
        </Breadcrumbs>
      )}
    />
  );
}
